import { useEffect, useState } from "react"; 

import NavBar from '../components/NavBar/NavBar.jsx'
import Banner from '../Componentes/Banners/Banner.jsx';
import UsoDelEquipo from '../Componentes/UsoDelEquipo/UsoDelEquipo.jsx';
import AlfinalizarElTrabajo5C from '../Componentes/AlFinalizarElTrabajo/AlFinalizarElTrabajo_5C.jsx';
import SolucionDeProblemas from '../Componentes/SolucionDeProblemas/SolucionDeProblemas.jsx';
import Video from "../Componentes/Video/video.jsx";
import ManualesYDocumentos2item from '../Componentes/ManualesYDocumentos/ManualesYDocumentos2item..jsx';
import RedesSociales from '../Componentes/RedesSociales/RedesSociales.jsx';
import Footer from '../Componentes/Footer/Footer.jsx'
import InfoPrincipal from '../Componentes/InfoPrincipal/InfoPrincipal.jsx';

import { obtenerDataBanner } from '../Componentes/infoJsons/infoBanner.js'
import { obtenerInfoPrin_SC6000 } from '../Componentes/infoJsons/infoPrincipal.js'
import { obtenerUSO_SC6000 } from '../Componentes/infoJsons/infoUsoDelEquipo.js'
import { obtenerAlfinalizarSC6000 } from "../Componentes/infoJsons/infoAlFinalizar.js";
import { obtenerSDP_SC6000 } from '../Componentes/infoJsons/infoSoluDeProble.js';

const SC6000 = () => {

      //Banner
      const [data, setData] = useState([]);
      //
    
      //inFo Principal
        const [infoPrinc, setInfoPrinc] = useState([]);
      //
    
      //UsoDelEquipo
        const [USO_SC6000, setUSO_SC6000] = useState([]);
      //
    
      //AL FINALIZAR EL TRABAJO
        const [final, setFinal] = useState([]);
      //

      //Solucion de Problemas
        const [SDP_SC6000, setSDP_SC6000] = useState([]);
      //
    
        useEffect(() => {
    
            //Banner
            obtenerDataBanner().then(myJson => {setData(myJson);});
    
            //INFOPRINCIPAL
            obtenerInfoPrin_SC6000().then(infoPrincipal => {setInfoPrinc(infoPrincipal);});
    
            //USODELEQUIPO
            obtenerUSO_SC6000().then(uso => {setUSO_SC6000(uso);});
            //
    
            //AL FINALIZAR EL TRABAJO
            obtenerAlfinalizarSC6000().then(final => {setFinal(final);});
            //

            //SOLUCION DE PROBLEMA
            obtenerSDP_SC6000().then(SDP => {setSDP_SC6000(SDP)});
            //
        }, []);

        const listas = [
        ]
        
        const listasDesc2 = [
        ]
        const listasDesc3 = []



        const videos = [
            "https://nilfiskchile.cl/assets/videos/F-SC6000/SC6000_guia_uso_mantencion_espannol_Nilfisk.mov"
          ];
          
          const posters = [
            "https://nilfiskchile.cl/assets/videos/F-SC6000/sc600b-video.jpg"
          ];
          
          const thumbnails = [
            "https://nilfiskchile.cl/assets/videos/F-SC6000/sc600b-video.jpg"
          ];

          const elementosCarrusel = [
            {
              imgSrc: "https://nilfiskchile.cl/assets/img/FregadoraSC6000/Manuales/catalogo.jpg",
              pdf: "https://nilfiskchile.cl/assets/img/FregadoraSC6000/Manuales/SC6000_Catalogo_espannol_Chile.pdf",
              label: 'Catálogo',
            },
            {
              imgSrc: "https://nilfiskchile.cl/assets/img/FregadoraSC6000/Manuales/uso-y-mantencion.jpg",
              pdf: "https://nilfiskchile.cl/assets/img/FregadoraSC6000/Manuales/SC6000_ Uso_mantencion_espannol_Chile.pdf",
              label: 'Uso y Mantencion',
            },
          ];

    return (

        <div>
            <NavBar/>
            <Banner imageClass="BannerFregadora" titulo={data.length > 0 ? data[0].tituloBarredora : ""} />
            <InfoPrincipal data={infoPrinc} listas={listas} listasDesc2={listasDesc2} listasDesc3={listasDesc3}/>
            <UsoDelEquipo data={USO_SC6000}/>
            <AlfinalizarElTrabajo5C data={final} />
            <SolucionDeProblemas problemas={SDP_SC6000}/>
            <Video videos={videos} posters={posters} thumbnails={thumbnails}  />
            <ManualesYDocumentos2item elementosCarrusel={elementosCarrusel} />
            <RedesSociales />
            <Footer />
        </div>

    );
};

export default SC6000;